/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { getDocument } from '@atlaskit/browser-apis';
import { LinkButton } from '@atlaskit/button/new';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const scrollToCliSection = (): void => {
	getDocument()?.getElementById('cli-1')?.scrollIntoView({
		behavior: 'smooth',
		block: 'start',
	});
};

const styles = cssMap({
	centerNav: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: token('space.100'),
		justifySelf: 'center',
		marginBottom: token('space.negative.050'),
		'@media (max-width: 48rem)': {
			display: 'none',
		},
	},
	button: {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		paddingBlock: token('space.100'),
		paddingInline: token('space.150'),
		border: 'none',
		borderRadius: token('radius.medium'),
		backgroundColor: 'transparent',
		color: 'inherit',
		font: 'inherit',
		cursor: 'pointer',
	},
});

type NavButtonsProps = {
	ariaLabel: string;
};

export const NavButtons = ({ ariaLabel }: NavButtonsProps): JSX.Element => (
	<nav css={styles.centerNav} aria-label={ariaLabel}>
		<LinkButton href="#about" appearance="subtle">
			<FormattedMessage {...messages.navAbout} />
		</LinkButton>
		<LinkButton href="#connectors" appearance="subtle">
			<FormattedMessage {...messages.navConnectors} />
		</LinkButton>
		<button type="button" css={styles.button} onClick={scrollToCliSection}>
			<FormattedMessage {...messages.navCliFirst} />
		</button>
		<LinkButton href="#docs" appearance="subtle">
			<FormattedMessage {...messages.navDocs} />
		</LinkButton>
	</nav>
);
